<form #icePortalForm method="post">
    <input type="hidden" id="EncryptedData" name="EncryptedData" />
</form>
